<template>
  <section class="deal-board">
    <div class="row compensate-padding-right">
      <div class="col-12 d-flex align-items-center">
        <div class="ml-3 my-2">
          <InputDropdown
            custom-class="f-w-600"
            :class="this.pipelines?.length > 1 ? 'pipeline-select' : 'pl-5 pipeline-select'"
            :items="filteredPipelines"
            :selected="pipeline.name"
            @select="(pipe) =&gt; setPipeline(pipe)"
            :size="7"
          />
          <img
              src="/build/icons/icon-pipeline.svg"
              width="16"
              height="16"
              alt="Ícone de gráfico de barras"
              class="position-absolute pipeline-icon-image-container"
          />
        </div>
        <div class="ml-3 position-relative">
          <InputDropdown
            custom-class="pl-5 f-w-600"
            :items="filteredStatus"
            :selected="this.status.name"
            :placeholder="'Selecione'"
            @select="(status) =&gt; setStatus(status)"
            :size="7"
          />
          <img
              src="/build/icons/hands-sale.svg"
              width="16"
              height="16"
              alt="Ícone do aperto de mão"
              class="position-absolute sales-icon-image-container"
          />
        </div>
        <div class="d-flex align-items-center ml-auto">
          <div class="d-lg2-inline d-none ml-4 position-relative">
            <input
            class="form-control search-field pl-5"
            type="text"
            name="filter"
            :placeholder="__('Digite para pesquisar...')"
            v-model="filter"
            @keydown.enter="getBoard()"
          />
          <img
            src="/build/icons/search-icon.svg"
            width="16"
            height="16"
            alt="Lupa do campo de pesquisa"
            class="position-absolute search-icon-image-container"
          />
          <a
            id="clear-search-field"
            class="position-absolute clear-search-field"
            aria-label="Close"
            v-show="filter"
            @click="clearSearchField"
          >
            <span aria-hidden="true">×</span>
          </a>
          </div>
        </div>
        <div class="ml-3 position-relative">
          <a
            class="btn btn-primary btn-configuration"
            @click="toggleDropdown"
          >
            <img src="/build/images/deal/icon-configuration.svg" />
          </a>
          <ul
            v-if="showDropdown"
            role="menu"
            tabindex="-1"
            class="dropdown-menu"
          >
            <li role="presentation">
              <a role="menuitem" href="/settings" target="_self" class="dropdown-item-drop">
                <span>Configurações</span>
              </a>
            </li>
            <li role="presentation">
              <a role="menuitem" href="#" class="dropdown-item-drop" @click.prevent="openModal">
                <span>Personalizar Cartão</span>
              </a>
            </li>
          </ul>
        </div>
        <div class=ml-3 id="sort-container">
          <button
            id="sort-button"
            class="sort-button"
          >
            <SortArrows v-if="option.name === 'Ordenar'"/>
            <Arrow
              v-else
              :direction="orderArrowDirection"
            />
            {{ __(option.name) }}
            <img
              v-if="option.name !== 'Ordenar'"
              :src="filterIconXWhite"
              width=18
              height=18
              @click.stop="removeOption"
            />
          </button>
          <BTooltip
            id="sort-tooltip"
            target="sort-button"
            placement="bottom"
            custom-class="sortTooltipArrow"
            :disabled="!sortTooltipTitle.length"
          >
            {{ sortTooltipTitle }}
          </BTooltip>
          <DealSortPopover
            :option="option"
            @optionSelected="optionSelected"
          />
        </div>
        <div class="ml-3" id="popover-container">
          <button
            class="btn btn-bulldesk f-w-600 deals-filter-button d-flex justify-content-center align-items-center"
            type="button"
            id="btn-filter"
            :class="filterButtonClass"
            @click="handleDateRangePickerPosition()"
            @mouseenter="onMouseEnter"
            @mouseleave="onMouseLeave"
            ref="closeButton"
          >
            <span id="btn-filter-span" class="ml-4 deals-filter-button-text">{{ __('Filtros') }}</span>
            <span style="display:none;" id="filterIconX" @click="cleanFilter">
              <img
              :src="defaultIcon"
              width="16"
              height="16"
              class="ml-2"/>
            </span>
          </button>
          <BPopover
            id="filters-popover"
            target="btn-filter"
            custom-class="modal-filter"
            container="popover-container"
            placement="top"
            boundary="window"
          >
            <div class="body-header">
              <button id="close-button" class="close" type="button" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="body-content col-12" id="body-content" ref="bodyContent">
              <div class="col-12" id="users-input-container">
                <label class="filter-user-label">Usuários</label>
                <Multiselect
                  label="name"
                  track-by="id"
                  :placeholder="__('Selecione')"
                  v-model="selectedUsers"
                  :options="filteredUsers"
                  :multiple="true"
                  :searchable="true"
                  :show-labels="false"
                  openDirection="bottom"
                  @open="updateMultiselectInputsPosition(200)"
                >
                  <template slot="noResult">{{ __('Nenhum resultado encontrado') }}</template>
                  <template slot="noOptions">{{ __('Nenhuma opção encontrada') }}</template>
                </Multiselect>
                <img
                  src="/build/icons/search-icon.svg"
                  width="16"
                  height="16"
                  alt="Lupa do campo de pesquisa"
                  class="position-absolute filter-icon"
                />
              </div>
              <div class="mt-3" id="create-date-container">
                <h3 class="filter-label mb-2">{{ __('Data de criação') }}</h3>
                <InputDaterange
                  id="create-date"
                  name="create-date"
                  custom-class="input-date-range-deals-board m-t-5"
                  theme="modern"
                  :start="14"
                  :placeholder="__('Selecione um período')"
                  v-model="createDateRange"
                  position="left"
                  preset="deals-board"
                />
              </div>
              <div class="mt-12px">
                <h3 class="filter-label mb-2">{{ __('Data de fechamento') }}</h3>
                <InputDaterange
                  id="close-date"
                  name="close-date"
                  custom-class="input-date-range-deals-board m-t-5"
                  theme="modern"
                  :start="14"
                  :placeholder="__('Selecione um período')"
                  v-model="closeDateRange"
                  position="left"
                  preset="deals-board"
                />
              </div>
              <div class="col-12 mt-12px" id="tags-input-container">
                <label class="filter-user-label">Tags</label>
                <Multiselect
                  label="name"
                  track-by="id"
                  :placeholder="__('Selecione')"
                  v-model="selectedTags"
                  :loading="isLoading"
                  :options="tags"
                  :multiple="true"
                  :searchable="true"
                  :show-labels="false"
                  openDirection="bottom"
                  @search-change="debouncedFetchTags"
                  @open="updateMultiselectInputsPosition(200)"
                >
                  <template v-if="!isLoadingTags && !this.searchTag && tags && totalTags > 30 && tags.length < totalTags" #afterList>
                    <div @click="loadMoreTags" class="load-more">Ver mais</div>
                  </template>
                  <template v-else-if="isLoadingTags" #afterList>
                    <i class="fa fa-circle-o-notch fa-spin load-more" />
                  </template>
                  <template slot="noResult">{{ this.searchTag.length >= 3 ? __('Nenhum resultado encontrado') : __('Digite ao menos 3 caracteres') }}</template>
                  <template slot="noOptions">{{ __('Nenhuma opção encontrada') }}</template>
                </Multiselect>
                <img
                  src="/build/icons/search-icon.svg"
                  width="16"
                  height="16"
                  alt="Lupa do campo de pesquisa"
                  class="position-absolute filter-icon"
                />
              </div>
              <div id="origins-input-container" class="col-12 mt-3">
                <h3 class="filter-label filter-user-label mt-3">{{ __('Origem') }}</h3>
                <Multiselect
                  label="name"
                  track-by="id"
                  :placeholder="isLoadingOrigins ? 'Aguarde, carregando origens...' : 'Todas'"
                  v-model="origin"
                  :options="origins"
                  :show-labels="false"
                  openDirection="bottom"
                  @open="updateMultiselectInputsPosition(200)"
                >
                  <template slot="caret">
                    <span class="search-icon-origin">
                      <img
                        src="/build/icons/search-icon.svg"
                        width="16"
                        height="16"
                        alt="Lupa do campo de pesquisa"
                        class="position-absolute filter-user-icon"
                      />
                    </span>
                  </template>
                  <template slot="noResult">{{ __('Nenhum resultado encontrado') }}</template>
                  <template slot="noOptions">{{ __('Nenhuma opção encontrada') }}</template>
                </Multiselect>
              </div>
              <div class="col-12 mt-3">
                <label class="filter-user-label">Atividades</label>
                <InputDropdown
                  custom-class="f-w-500"
                  class="filter-activities"
                  :items="activities"
                  :selected="activity.name"
                  @select="(activity) =&gt; setActivity(activity)"
                  :size="7"
                  offset="0,4"
                  truncateAt="40"
                />
              </div>
              <div class="w-100 d-flex justify-content-center mt-32px">
                <button
                  id="clear-filters-button"
                  :disabled="clearFiltersButtonDisabled"
                  @click="clearFilter"
                >
                  {{ __('Limpar filtro') }}
                </button>
              </div>
            </div>
            <div id="baseboard" class="baseboard col-12 d-flex">
              <span>Quer sugerir novos filtros? </span><a href="#" @click="openSuggestionFiltersModal">Clique aqui</a>
            </div>
          </BPopover>
        </div>
      </div>
    </div>
    <div
      :style="{top: board.scroll.top + 'px'}"
      class="row compensate-padding-right scrollable-controls p-0"
      v-if="board.scroll.top"
    >
      <div class="pull-front d-flex align-items-center w-100">
        <button
          class="left btn mr-auto"
          v-show="board.scroll.left"
          @click="boardScrollX(-220)"
        >
          <IconSalesflowChevron
            :direction="'left'"
            :color="board.scroll.left ? '#886AF8' : ''"
          />
        </button>
        <button
          class="right btn ml-auto"
          @click="boardScrollX(220)"
        >
          <IconSalesflowChevron
            :direction="'right'"
            :color="board.scroll.right ? '#886AF8' : ''"
          />
        </button>
      </div>
    </div>
    <div
      class="row mt-2"
      id="deal-content"
    >
      <div class="p-0 col-md-12">
        <div class="scrollable-visible">
          <div id="board">
            <div
              class="column-list"
              @wheel="wheelBoardScrollX"
            >
              <div
                class="columns"
                v-for="(column, colIndex) in columns"
                :key="column.id"
                :data-column="column.id"
                :style="{ 'min-width': board.columnWidth + 'px' }"
              >
                <div
                  class="header"
                  :class="{ first: colIndex === 0, last: colIndex === columns.length - 1 }"
                >
                  <div
                    class="arrow"
                    v-if="colIndex !== 0"
                  >
                    <img
                      src="/build/icons/deal-arrow.svg"
                      width="14"
                      height="73"
                      alt="Arrow"
                    >
                  </div>
                  <div class="content">
                    <div
                      class="title capitalize"
                      :alt="column.name"
                      :title="column.name"
                    >
                      {{ __(column.name) | truncate('20') }}
                    </div>
                    <div class="subtitle">
                      {{ column.cards ? total(column.cards) : column.money |
                        currency(0) }} {{ __('em') }} {{ column.cards ?
                        count(column.cards) : 0 }}<span
                        v-if="maxCards(column.id) &gt; count(column.cards)"
                      >
                        {{ __('de') }} {{ maxCards(column.id) }}</span>
                      {{ __('negócios') }}
                    </div>
                  </div>
                </div>
                <Draggable
                  class="cards card-list"
                  tag="ul"
                  :class="{ first: colIndex == 0, last: colIndex == (columns.length - 1) }"
                  v-bind="draggable"
                  v-model="columns[colIndex].cards"
                  @change="move"
                  @start="startDrag"
                  @end="endDrag"
                >
                  <li
                    class="card"
                    :key="card.id"
                    v-for="card in filterCards(column.cards)"
                    @click="open(card)"
                  >
                  <div
                    class="row" 
                    :class="{ 'opportunity-border': card.lead?.opportunity }"
                    v-if="card && card.lead"
                  >
                    <div class="deal-card-body col-12 p-3">
                      <div id="deal-card-body-top-wrapper" class="d-flex flex-row justify-content-between align-items-start col-12 px-0 mx-0 mh-39">
                        <div id="deal-card-title" class="d-flex flex-column flex-grow-1 pe-2" style="min-width: 0;">
                          <h5 class="title fw-bold fs-6 lh-20 purple-text font-montserrat" 
                              style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                            {{ card.title || card.lead.name || card.lead.email }}
                          </h5>
                          <span class="value fw-semibold fs-7 lh-18 font-montserrat">
                            {{ card.value | currency(0) }}
                          </span>
                        </div>
                        <div id="deal-card-gauges" 
                            class="d-flex flex-row justify-content-end align-items-center gap-2-3 col-auto px-0 mx-0" 
                            style="flex-shrink: 0;">
                          <DealCardActivity
                            class="float-right"
                            :deal="card"
                            :lead="card.lead"
                            :placement="(colIndex >= (columns.length - 2)) ? 'right' : 'left'"
                            :open-modal="open"
                            v-if="card.lead"
                          />
                          <div id="deal-card-thermometer">
                            <div class="rounded-square-32 d-flex justify-content-center align-items-center bg radius-8"
                                :class="dealTemperatureStyles[card.temperature.temperature_label]?.bgClass"
                                v-b-tooltip.right 
                                :title="__('Negócio ') + ' ' + __(card.temperature.temperature_label)">
                              <component :is="dealTemperatureStyles[card.temperature.temperature_label]?.icon"></component>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="cachedCardConfig && card.lead" class="configuration-container mt-3">
                        <div
                          v-for="(config, index) in cachedCardConfig.configuration"
                          :key="config"
                          class="dynamic-configuration"
                          :class="{ 'left': index < 2, 'right': index >= 2 }"
                        >
                          <span
                            v-b-tooltip="{
                              customClass: 'ml-1',
                              placement: 'right',
                              trigger: 'hover',
                            }"
                            :title="getDescription(config)"
                            class="d-inline-flex align-items-center config-container"
                          >
                            <component
                              v-if="getIcon(config)"
                              :is="getIcon(config)"
                              class="icon-class"
                            />
                            <span class="config-label">{{ getLabel(config, card) }}</span>
                          </span>
                        </div>
                      </div>
                      <div id="deal-card-border" class="border-bottom w-100 border-light-gray my-1-5"></div>

                      <!-- Rodapé do cartão do negócio -->
                      <div id="deal-card-body-footer-wrapper" class="d-flex flex-row justify-content-between align-items-center align-content-center">
                        <div id="deal-card-owner-data">
                          <p class="mb-0 text-gray lh-14">{{ __('Dono do negócio') }}</p>
                          <p v-if="card.user" class="mb-0 text-gray-strong fw-semibold fs-8 lh-sm">
                            {{ card.user?.name || '-' | truncate('20') }}
                          </p>
                        </div>
                        <div id="deal-card-date-data" class="col-6 px-0 d-flex flex-row gap-1 justify-content-end">
                          <div id="deal-card-created-at" class="rounded-square-32 d-flex justify-content-center align-items-center bg-gray-light filled-clock"
                              v-b-tooltip.html.bottom :title="'<span style=\'font-weight: 400;\'>' + formatCreatedDate(card.created_at) + '</span>'">
                            <FilledClock :color="squareIconColor"/>
                          </div>
                          <div id="deal-card-date-expected-at" class="rounded-square-32 d-flex justify-content-center align-items-center bg-gray-light hourglass"
                              v-b-tooltip.html.bottom :title="'<span style=\'font-weight: 400;\'>' + formatExpectedDate(card.expected_at) + '</span>'">
                            <Hourglass />
                          </div>
                          <div id="deal-card-date-stagnation" class="rounded-square-32 d-flex justify-content-center align-items-center bg-gray-light"
                              :class="showStagnationIcon(card.stagnation_time, card.time_in_stage).class"
                              v-b-tooltip.html.right :title="'<span style=\'font-weight: 400;\'>' + formatStagnationTime(card.stagnation_time, card.time_in_stage) + '</span>'">
                            <component :is="showStagnationIcon(card.stagnation_time, card.time_in_stage).icon" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  </li>
                  <span
                    class="load-more d-block text-center"
                    v-if="column.cards &amp;&amp; column.cards.length &amp;&amp; canPaginate(pages[column.id]) &amp;&amp; !loading"
                  ><a
                    class="btn load-more"
                    href="#"
                    @click.prevent="getCards(column.id, colIndex, boardHash, pages[column.id].current_page)"
                  >
                    <u>{{ __('Carregar mais') }}</u></a></span>
                </Draggable>
                <div
                  :class="'bottom-status-width-sidebar-' + sidebarStatus"
                  class="bottom-status hidden-sm hidden-xs dynamic-width"
                  v-if="colIndex === 0 &amp;&amp; dragging"
                >
                  <div class="row no-gutter">
                    <div class="col-md-2 pr-0 pl-0">
                      <Draggable
                        class="btn btn-block destroy"
                        tag="button"
                        v-bind="droppable"
                        @add="drop($event, 'destroy')"
                      >
                        {{ __('Excluir') }}<i class="fa fa-trash-o ml-1" />
                      </Draggable>
                    </div>
                    <div class="col-md-5 pr-0 pl-0">
                      <Draggable
                        class="btn btn-block lost"
                        tag="button"
                        v-bind="droppable"
                        v-if="status.current != 'lost'"
                        @add="drop($event, 'lost')"
                      >
                        {{ __('Perdido') }}<i class="fa fa-times ml-1" />
                      </Draggable>
                      <Draggable
                        class="btn btn-block open"
                        tag="button"
                        v-bind="droppable"
                        v-if="status.current == 'lost'"
                        @add="drop($event, 'open')"
                      >
                        {{ __('Aberto') }}<img
                          class="ml-1"
                          src="/build/icons/open-folder.svg"
                          width="20"
                          height="19"
                        >
                      </Draggable>
                    </div>
                    <div class="col-md-5 pr-0 pl-0">
                      <Draggable
                        class="btn btn-block closed"
                        tag="button"
                        v-bind="droppable"
                        v-if="status.current != 'closed'"
                        @add="drop($event, 'closed')"
                      >
                        {{ __('Ganho') }}<img
                          class="ml-1"
                          src="/build/icons/dollar.svg"
                          width="20"
                          height="19"
                        >
                      </Draggable>
                      <Draggable
                        class="btn btn-block open"
                        tag="button"
                        v-bind="droppable"
                        v-if="status.current == 'closed'"
                        @add="drop($event, 'open')"
                      >
                        {{ __('Aberto') }}<img
                          class="ml-1"
                          src="/build/icons/open-folder.svg"
                          width="20"
                          height="19"
                        >
                      </Draggable>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DealWonReasonModal />
    <DealLostReasonModal />
    <DealOpenReasonModal />
    <DealModal
      :user="user"
      :pipelines="pipelines"
    />
    <DealDeleteModal
      @confirmDeletion="confirmDeletion"
    />
    <FinishActivityModal
      ref="finishActivityModal"
      :activity-id="activityToFinish?.id"
      :activity="activity"
      :card-hash="cardHash"
      @confirmFinish="handleFinishActivity"
    />
    <div id="customize-card-modal" class="custom-modal" v-if="showModal">
      <div class="custom-modal-dialog">
        <div class="custom-modal-content">
          <div class="custom-modal-header">
            <h5 class="custom-modal-title">Personalizar cartão de negócio</h5>
          </div>
          <div class="custom-modal-body">
            <p class="custom-modal-subtitle">Configure aqui até 4 informações que deseja visualizar no cartão de negócio.</p>
            <div class="options-list">
              <label v-for="option in options" :key="option.id" class="option-item">
                <input 
                  type="checkbox" 
                  :value="option.id" 
                  v-model="selectedOptions" 
                  :disabled="selectedOptions.length >= 4 && !selectedOptions.includes(option.id)" 
                  :class="{ 'disabled-checkbox': selectedOptions.length >= 4 && !selectedOptions.includes(option.id) }"
                />
                <span 
                  class="option-icon" 
                  :class="{ 'disabled-icon': selectedOptions.length >= 4 && !selectedOptions.includes(option.id) }"
                >
                  <component :is="option.icon" />
                </span>
                <span 
                  class="option-label" 
                  :class="{ 'disabled-text': selectedOptions.length >= 4 && !selectedOptions.includes(option.id) }"
                >
                  {{ option.label }}
                </span>
              </label>
            </div>
          </div>
          <div class="custom-modal-footer">
            <button class="btn btn-save" :disabled="!isValidSelection" @click="saveSelection">Salvar</button>
            <span class="btn-cancel-text" @click="closeModal">Cancelar</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import dayjs from '../../core/dayjs';
import { BButtonGroup, BTooltip, VBTooltip, BPopover } from 'bootstrap-vue';
import Swal from 'sweetalert2';
import { debounce } from '../../helpers/debounce';
import { Alert } from '../../services/alert.js';
const Strings = require('../../services/strings.js');
import SortArrows from '../icon/SortArrows.vue';
import Arrow from '../icon/Arrow.vue';
import axios from 'axios';
import CardHeading from '../icon/CardHeading.vue';
import CheckCircleFilled from '../icon/CheckCircleFilled.vue';
import DealOpenReasonModal from './ReasonModal/DealOpen/DealOpenReasonModal.vue';
import DealLostReasonModal from './ReasonModal/DealLost/DealLostReasonModal.vue';
import DealWonReasonModal from './ReasonModal/DealWon/DealWonReasonModal.vue';
import FinishActivityModal from '../activity/FinishActivityModal.vue';
import ExclamationOctagonFilled from '../icon/ExclamationOctagonFilled.vue';
import Funnel from '../icon/Funnel.vue';
import FireOutline from '../icon/FireOutline.vue';
import IceCrystal from '../icon/IceCrystal.vue';
import FilledClock from '../icon/FilledClock.vue';
import Hourglass from '../icon/Hourglass.vue';
import LowWaves from '../icon/LowWaves.vue';
import Location from '../icon/Location.vue';
import PersonCircle from '../icon/PersonCircle.vue';
import PersonBadge from '../icon/PersonBadge.vue';
import ShopWindow from '../icon/ShopWindow.vue';

const MIN_COLUMN_WIDTH = 340;
const FALLBACK_SCROLLABLE_TOP_MARGIN = 200;
const SWAL_WIDTH = 350;

const multiselectConfigs = [
  { id: 'users-input-container', defaultTop: 104 },
  { id: 'tags-input-container', defaultTop: 362 },
  { id: 'origins-input-container', defaultTop: 448 },
];

export default {
  components: {
    BButtonGroup,
    BPopover,
    BTooltip,
    SortArrows,
    Arrow,
    DealOpenReasonModal,
    DealLostReasonModal,
    DealWonReasonModal,
    FinishActivityModal,
    LowWaves,
    FireOutline,
    IceCrystal,
    FilledClock,
    Hourglass,
    ExclamationOctagonFilled,
    PersonCircle,
    ShopWindow,
    PersonBadge,
    CheckCircleFilled,
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  props: ['reasons', 'stages', 'user', 'pipelines', 'currentPipeline'],

  store: ['users'],

  data () {
    const self = this;

    return {
      cardHash: null,
      activityToFinish: null,
      showFinishModal: false,
      showModal: false,
      options: [
        { id: 1, label: "Nome do Lead", key: "name", icon: PersonCircle },
        { id: 2, label: "Profissão / Cargo", key: "occupation", icon: PersonBadge },
        { id: 3, label: "Empresa", key: "company", icon: ShopWindow },
        { id: 4, label: "Localização", key: "location", icon: Location },
        { id: 5, label: "Origem", key: "origin", icon: Funnel },
        { id: 6, label: "CPF / CNPJ", key: "document", icon: CardHeading },
      ],
      selectedOptions: [],
      originalSelection: [],
      squareIconColor: '#B6C3D2',
      showReasonModal: null,
      showDropdown: false,
      sidebarStatus: 'collapsed',
      isSidebarCollapsed: false,
      isLoadingTags: false,
      filterIconX: '/build/icons/icon-clean-filters-x.svg',
      filterIconXWhite: '/build/icons/icon-clean-filters-x-white.svg',
      defaultIcon:'',
      currentPage: 1,
      isLoading: false,
      searchTag: '',
      activity: {
        id: '',
        name: 'Todas',
      },
      board: {
        width: 0,
        columnWidth: 0,
        scrollable: false,
        scroll: {
          left: false,
          right: false,
          top: false,
        },
      },
      boardHash: "",
      cards: [],
      clearFiltersButtonDisabled: true,
      closeDateRange: '',
      columns: [],
      createDateRange: '',
      current: false,
      defaultDateRangeMeasures: {
        top: 116,
        right: 20
      },
      draggable: {
        group: 'cards',
        filter: '.load-more',
      },
      dragging: false,
      droppable: {
        sort: false,
        group: 'cards',
        draggable: '.card',
        ghostClass: 'd-none',
      },
      dropping: false,
      filter: '',
      inputDateRangePosition: 'left',
      isLoadingOrigins: false,
      isOpened: false,
      loading: true,
      moving: false,
      origin: {
        id: '',
        name: 'Todas'
      },
      origins: [],
      pages: [],
      pipeline: null,
      queue: [],
      range: '',
      scrollHeight: 0,
      selectedTags: [],
      selectedUsers: [],
      status: {
        current: 'open',
        name: 'Abertos',
        names: {
          open: 'Abertos',
          closed: 'Ganhos',
          lost: 'Perdidos',
        },
      },
      tags: [],
      totalTags:0,
      updatingBoard: false,
      user_id: '',
      user_name: '',
      option: {
        name: 'Ordenar'
      },
      dealToDelete: null,
      dealToBeUpdated: null,
      tenantId: this.user.tenant_id,
      userId: this.user.id,
      cachedCardConfig: null,
      dealTemperatureStyles: {
        warm: {
          bgClass: 'neutral-deal',
          icon: 'LowWaves'
        },
        hot: {
          bgClass: 'hot-deal',
          icon: 'FireOutline'
        },
        cold: {
          bgClass: 'cold-deal',
          icon: 'IceCrystal'
        }
      },
    };
  },

  computed: {

    isValidSelection() {
      return this.selectedOptions.length >= 1 && this.selectedOptions.length <= 4;
    },

    filterButtonClass() {
      if (this.selectedUsers && this.selectedUsers.length >= 1 ||
          this.selectedTags && this.selectedTags.length >= 1 ||
          (this.activity && this.activity.id) ||
          this.createDateRange != '' ||
          this.closeDateRange != '' ||
          (this.origin && this.origin.id)
      ){
        document.getElementById('filterIconX').style.display = 'block';
        if (this.isOpened) {
          this.defaultIcon = this.filterIconXWhite;
          return "deals-filter-button-filled-focus";
        } else {
          this.defaultIcon = this.filterIconX;
          return "deals-filter-button-filled";
        }
      }

      if (document.getElementById('filterIconX') != null){
        document.getElementById('filterIconX').style.display = 'none';
      }
      return !this.isOpened ? "deals-filter-button" : "deals-filter-button-focus";
    },
    activities () {
      return [
        {
          id: '',
          name: 'Todas'
        },
        {
          id: 'today',
          name: 'Agendadas para hoje'
        },
        {
          id:'week',
          name: 'Agendadas para esta semana'
        },
        {
          id:'month',
          name: 'Agendadas para este mês'
        },
        {
          id: 'late',
          name: 'Atrasadas'
        },
        {
          id: 'finalized',
          name: 'Finalizadas'
        },
        {
          id: 'without',
          name: 'Sem atividade'
        },

      ];
    },
    filteredPipelines () {
      return this.pipelines.filter((pipeline) => pipeline.id != this.pipeline.id && pipeline.stages.length > 0);
    },

    filteredStatus() {
      return [
        {
          name: 'Abertos',
          type: 'open'
        },
        {
          name: 'Ganhos',
          type: 'closed'
        },
        {
          name: 'Perdidos',
          type: 'lost'
        },
      ]
    },

    filteredUsers () {
      const users = this.users.filter((user) => user.id != this.user_id);

      return users;
    },

    orderArrowDirection() {
      return this.option.order === 'asc' ? 'up' : 'down';
    },

    sortTooltipTitle() {
      let { name, order } = this.option;
      if (name === 'Ordenar') return '';
      order = order === 'asc' ? 'crescente' : 'decrescente';
      return `${this.__('Visualizando em')} ${this.__(name).toLowerCase()} ${this.__(order)}`;
    },

    shouldApplySort() {
      return this.option.value;
    }
  },

  watch: {
    'status.current': function () {
      this.getBoard();
    },

    'dragging': function () {
      this.checkIfSidebarIsCollapsed(this.isSidebarCollapsed);
    },

    'isSidebarCollapsed': function () {
      this.checkIfSidebarIsCollapsed(this.isSidebarCollapsed);
    },

    loading () {
      this.runQueue();
    },

    filter() {
      this.debouncedFetch();
    },

    selectedTags(...args) {
      this.debouncedFetch(args[0].length > 0 ? args[0][0].id  : null);
      this.updateMultiselectInputsPosition(200);
    },

    selectedUsers(...args) {
      this.debouncedFetch(args[0].length > 0 ? args[0][0].id  : null);
      this.updateMultiselectInputsPosition(200);
    },

    origin(...args) {
      this.debouncedFetch(args.length > 0 ? args[0].id : null);
      this.updateMultiselectInputsPosition(200);
    },

    createDateRange(...args) {
      this.debouncedFetch(args[0].length > 0 ? args[0] : null);
    },

    closeDateRange(...args) {
      this.debouncedFetch(args[0].length > 0 ? args[0] : null);
    },

    activity(...args) {
      this.debouncedFetch(args.length > 0 ? args[0].id : null);
    },

    currentPipeline: {
      handler(newPipeline) {
        this.pipeline = newPipeline;
      },
      immediate: true,
    }
  },
  /**
   * Preciso dizer que deve habilitar botão de limpar filtro apenas se for uma pesquisa com filtro
   */

  created () {
    this.debouncedFetchTags = debounce((search) => {
      this.searchTag = search;
      if (this.searchTag == '' || this.searchTag.length >= 3){
        if (this.searchTag.length >= 1) {
          this.currentPage = 1;
        }
        this.isLoading = true;
        this.getTags();
      }
    }, 500);

    this.debouncedFetch = debounce((isCleaning) => {
      if (isCleaning) {
        this.setClearFiltersButtonDisabled(false);
      } else if (!this.selectedTags?.length > 0 && !this.selectedUsers?.length > 0 && !this.closeDateRange && !this.createDateRange && !this.origin.id && !this.activity.id) {
        this.setClearFiltersButtonDisabled(true);
      }

      this.getBoard();
    }, 1500);

    this.loadCards();
    this.getTags();
    this.getOrigins();
    this.setPipeline(this.currentPipeline);
    this.loadCachedCardConfig();
    // this.getOrigins();

    window.addEventListener('resize', () => {
      this.calculateBoardSize();
      this.calculateInputDateRangePosition();
    });
    window.addEventListener('scroll', () => this.handleWindowScroll());

    Bus.$on('markCardAs', (data) => {
      const card = data[0];
      const status = data[1];

      this.addQueue(() => this.markAs(card, status));
    });

    Bus.$on('moveCard', (data) => {
      const card = data[0];
      const from_id = data[1];
      const to_id = data[2];

      this.addQueue(() => this.move(card, from_id, to_id, null));
    });

    Bus.$on('getBoard', () => this.getBoard());
    Bus.$on('dealCreated', ({ column }) => setTimeout(() => this.reloadColumn(column), 1000));
    Bus.$on('removeCard', (card) => this.addQueue(() => this.remove(card)));
    Bus.$on('updateCard', ({ card, column }) => this.addQueue(() => this.update(card, column)));

    Bus.$on('opportunity-change', ({ hash, opportunity }) => {
      this.columns.forEach((column, columnIndex) => {
        const card = column.cards.find(card => card.lead?.hashid === hash);
        if (card) {
          card.lead.opportunity = opportunity;
          this.$forceUpdate();
        }
      });
    });

    Bus.$on('temperature-saved', () => {
      this.getBoard();
    });

    Bus.$on('sidebarToggled',  ({isCollapsed} = isCollapsed)  => {
      this.isSidebarCollapsed = isCollapsed;
    });

    Bus.$on('reinsertDeal', () => this.reinsertDealIntoBoard());
  },

  mounted () {
    Bus.$on('openFinishActivityModalBoard', ({ activity, cardHash }) => {
      if (activity?.completed_at) return;

      this.activityToFinish = activity;
      this.cardHash = cardHash;
      this.showFinishModal = true;

      this.$nextTick(() => {
        const modal = this.$refs.finishActivityModal;
        if (modal) {
          modal.handleOpen({ activity, cardHash });
        } else {
          Bus.$emit('openFinishActivityModal', { activity, cardHash });
        }
      });
    });
    this.pipeline = this.currentPipeline;
    Bus.$on('askShouldCreateAnotherDeal', (card) => this.askShouldCreateAnotherDeal(card));
    this.calculateInputDateRangePosition();
    this.handleWindowScroll();
    this.openCloseModalFilter();
    document.addEventListener("click", this.handleClickOutside);
  },

  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },

  destroyed () {
    if (this.$refs.bodyContent) {
      this.$refs.bodyContent.removeEventListener("scroll", this.scrollHandler)
    }
  },

  methods: {
    handleFinishActivity({ activity: rawActivity, completed_status, closeModal }) {
      const activity = rawActivity?.activity;
      const activityId = activity?.id;

      this.$http.put(`/lead/${this.cardHash}/activity/${activityId}`, {
        complete: true,
        completed_status: completed_status
      })
      .then(() => {
        Alert.success('Atividade finalizada com sucesso');
        closeModal();
        this.getBoard();
      })
      .catch(() => {
        Alert.error('Erro ao finalizar atividade');
      });
    },

    async loadCachedCardConfig() {
      if (this.cachedCardConfig || this.isLoadingCardConfig) return;

      this.isLoadingCardConfig = true;

      try {
        const response = await this.$http.get('/deal-cards/current');
        this.cachedCardConfig = response.data || {};
      } catch (error) {
        console.error("Erro ao buscar configuração do cartão:", error);
      } finally {
        this.isLoadingCardConfig = false;
      }
    },

    async loadCardsWithConfiguration() {
      try {
        const cardConfig = await this.fetchCard();

        this.columns.forEach((column) => {
          column.cards.forEach((card) => {
              card.configuration = card.configuration;
          });
        });
      } catch (error) {
        console.error("[loadCardsWithConfiguration] Erro:", error);
      }
    },

    getIcon(config) {
      const icons = {
        "name": PersonCircle,
        "occupation": PersonBadge,
        "company": ShopWindow,
        "location": Location,
        "origin": Funnel,
        "document": CardHeading,
      };
      return icons[config] || null;
    },

    getLabel(config, deal) {
      if(!deal) return '--';

      const labels = {
        "name": deal.lead?.name || '--',
        "occupation": deal.lead?.occupation || '--',
        "company": deal.lead?.company || '--',
        "location": deal.lead?.city && deal.lead?.state && deal.lead?.country
          ? `${deal.lead.city} - ${deal.lead.state} - ${deal.lead.country}`
          : deal.lead?.city || deal.lead?.state || deal.lead?.country || '--',
        "origin": deal.origin_name || '--',
        "document": deal.lead?.document || '--',
      };
      return labels[config];
    },

    getDescription(config) {
      return this.options.find(option => option.key === config)?.label || '--';
    },

    async loadCards() {
      try {
        const cardConfig = await this.fetchCard();

        this.columns.forEach((column) => {
          column.cards.forEach((card) => {
            card.configuration = cardConfig?.configuration || card.configuration || [];
          });
        });
      } catch (error) {
        console.error("Erro ao carregar cartões:", error);
      }
    },

    getCardDataForConfiguration(card, config) {
      const mapping = {
      "name": card.lead.name,
      "occupation": card.lead.occupation,
      "company": card.lead.company,
      "location": card.lead.location,
      "origin": card.lead.origin,
      "document": card.lead.document,
    };

    return mapping[config];
    },

    async fetchCard() {
      try {
        if (this.cachedCardConfig) {
          return this.cachedCardConfig;
        }

        await this.loadCachedCardConfig();
        return this.cachedCardConfig;
      } catch (error) {
        if (error.response?.status === 404) {
          console.warn("Nenhuma configuração personalizada encontrada, aplicando padrão.");
        } else {
          console.error("Erro ao buscar configuração do cartão:", error);
          throw error;
        }
      }
    },

    async saveSelection() {
      try {
        const optionMap = {
          1: "name",
          2: "occupation",
          3: "company",
          4: "location",
          5: "origin",
          6: "document"
        };

        const transformedOptions = this.selectedOptions.map(optionId => optionMap[optionId] || optionId.toString());

        const payload = {
          configuration: transformedOptions,
        };

        const csrfToken = { headers: { 'X-CSRF-TOKEN': document.getElementById('csrf-token').content } };
        const response = await axios.post('/deal-cards', payload, csrfToken);

        this.originalSelection = [...this.selectedOptions];
        this.closeModal();
        Alert.success("Atualizado com sucesso!");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } catch (error) {
        console.error("[saveSelection] Erro ao salvar configurações:", error.message);
        if (error.response) {
          console.error("[saveSelection] Detalhes do erro do backend:", error.response.data);
        }
      }
    },

    async openModal() {
      try {
        const response = await this.$http.get('/deal-cards/current');
        
        if (response.data) {
          this.cachedCardConfig = response.data;

          if (this.cachedCardConfig.configuration) {
            this.selectedOptions = this.cachedCardConfig.configuration.map(configKey => {
              const option = this.options.find(opt => opt.key === configKey);
              return option ? option.id : null;
            }).filter(id => id !== null);
          } else {
            this.selectedOptions = [];
          }
        }

        this.originalSelection = [...this.selectedOptions];
        this.showModal = true;
      } catch (error) {
        console.error("[openModal] Erro ao carregar configurações:", error.message || error);
        this.selectedOptions = [];
      }
    },

    closeModal() {
      this.showModal = false;
      this.selectedOptions = [...this.originalSelection];
    },

    validateSelection() {
      if (this.selectedOptions.length > 4) {
        this.selectedOptions.pop();
      }
    },

    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },

    handleClickOutside(event) {
        const dropdown = this.$el.querySelector(".dropdown-menu");
        const button = this.$el.querySelector(".btn-configuration");

        if (dropdown && !dropdown.contains(event.target) && button && !button.contains(event.target)) {
            this.showDropdown = false;
        }
    },
         
    nameOrDash(name) {
      return name || '-';
    },

    showStagnationIcon(stagnationTime, timeInStage) {
      return this.isDealStagnated(stagnationTime, timeInStage) ? {
        icon: 'ExclamationOctagonFilled',
        class: 'exclamation-octagon-filled'
      } : {
        icon: 'CheckCircleFilled',
        class: 'check-circle-filled'
      };
    },
    
    isDealStagnated(stagnationTime, timeInStage) {
      return stagnationTime > 0;
    },

    formatCreatedDate(date) {
      return date ? 'Cadastrado em ' + this.$options.filters.datetime(date, 'LD') + ' às ' + this.$options.filters.datetime(date, 'HH:mm') : '-';
    },

    formatExpectedDate(date) {
      return date ? 'Fechamento esperado em ' + this.$options.filters.datetime(date, 'LD') : 'Sem data de fechamento';
    },

    formatStagnationTime(stagnationTime, timeInStage) {
      if (timeInStage === 0) {
        return 'Entrou no estágio hoje';
      }

      if (stagnationTime <= 0) {
        return timeInStage ? 'No estágio há ' + timeInStage + (timeInStage > 1 ? ' dias' : ' dia') : '-';
      }

      let days = stagnationTime > 1 ? ' dias' : ' dia';

      return 'Estagnado há ' + stagnationTime + days;
    },

    checkIfSidebarIsCollapsed(isCollapsed) {
      this.isSidebarCollapsed = document.querySelector('.the-sidebar').classList.contains('collapsed');

      if (this.dragging) {

        if (!isCollapsed) {
          this.sidebarStatus = 'opened';
        } else {
          this.sidebarStatus = 'collapsed';
        }
      }
    },

    onMouseEnter() {
      if (document.getElementById("btn-filter").classList.contains("deals-filter-button-filled")) {
        this.defaultIcon = this.filterIconXWhite;
      }
    },

    onMouseLeave() {
      if (document.getElementById("btn-filter").classList.contains("deals-filter-button-filled")) {
        this.defaultIcon = this.filterIconX;
      }
    },

    cleanFilter () {
      this.selectedUsers = [];
      this.selectedTags = [];
      this. activity = {
        id: '',
        name: 'Todas',
      }
      this.createDateRange = '';
      this.closeDateRange = '';
      this.origin = {
        id: '',
        name: 'Todas',
      };

      this.isOpened = false;
      document.getElementById('btn-filter').click();
    },

    async loadMoreTags() {
      this.currentPage++;
      this.getTags();
    },

    setClearFiltersButtonDisabled(clearFiltersButtonDisabled) {
      if (this.clearFiltersButtonDisabled !== clearFiltersButtonDisabled) {
        this.clearFiltersButtonDisabled = clearFiltersButtonDisabled;
      }
    },

    clearSearchField () {
      this.filter = '';
    },

    openSuggestionFiltersModal () {
      if (this.$refs.closeButton) {
        this.isOpened = false;
        this.$refs.closeButton.click();
        document.getElementById("btn-filter").classList.remove("deals-filter-button-focus");
      }
      userGuiding.launchSurvey(1774);
    },

    clearFilter() {
      this.setClearFiltersButtonDisabled(true);

      if (this.selectedTags?.length > 0) {
        this.selectedTags = [];
      }

      if (this.selectedUsers?.length > 0) {
        this.selectedUsers = [];
      }

      if (this.closeDateRange) {
        this.closeDateRange = '';
      }

      if (this.createDateRange) {
        this.createDateRange = '';
      }

      this.origin = {
        id: '',
        name: 'Todas'
      };

      this.activity = {
        id: '',
        name: 'Todas'
      };
    },

    handleDateRangePickerPosition () {
      setTimeout(() => {
        if (this.$refs.bodyContent) {
          this.$refs.bodyContent.addEventListener('scroll', this.scrollHandler);
          const createDateRangePickerInput = document.getElementById('create-date');
          const closeDateRangePickerInput = document.getElementById('close-date');

          if (createDateRangePickerInput && closeDateRangePickerInput) {
            createDateRangePickerInput.addEventListener("click", e => {
              const usersFilterHeight = document.getElementById('users-input-container').offsetHeight;
              const createDateTopSize = this.defaultDateRangeMeasures.top + usersFilterHeight;
              document.querySelector("#create-date .daterangepicker").style.top = `${createDateTopSize - this.scrollHeight}px`;
              document.querySelector("#create-date .daterangepicker").style.right = `${this.defaultDateRangeMeasures.right}px`;
            });

            closeDateRangePickerInput.addEventListener("click", e => {
              const usersFilterHeight = document.getElementById('users-input-container').offsetHeight;
              const createDateTopSize = this.defaultDateRangeMeasures.top + usersFilterHeight;
              const closeDateTopSize = createDateTopSize + document.getElementById('create-date-container').offsetHeight + 12;
              document.querySelector("#close-date .daterangepicker").style.top = `${closeDateTopSize - this.scrollHeight}px`;
              document.querySelector("#close-date .daterangepicker").style.right = `${this.defaultDateRangeMeasures.right}px`;
            });
          }
        }
      }, 200);
    },

    updateDateRangePosition() {
      const createDateTopSize = this.defaultDateRangeMeasures.top + document.getElementById('users-input-container').offsetHeight;
      const closeDateTopSize = createDateTopSize + document.getElementById('create-date-container').offsetHeight + 12;

      const createDateInput = document.querySelector("#create-date .daterangepicker");
      const closeDateInput = document.querySelector("#close-date .daterangepicker");

      if (createDateInput) {
        createDateInput.style.top = `${createDateTopSize - this.scrollHeight}px`;
        createDateInput.style.right = `${this.defaultDateRangeMeasures.right}px`;
      }

      if (closeDateInput) {
        closeDateInput.style.top = `${closeDateTopSize - this.scrollHeight}px`;
        closeDateInput.style.right = `${this.defaultDateRangeMeasures.right}px`;
      }
    },

    updateMultiselectInputsPosition (timeout) {
      setTimeout(() => {
        const usersFilter = document.getElementById('users-input-container');
        const tagsFilter = document.getElementById('tags-input-container');

        for (const { id, defaultTop } of multiselectConfigs) {
          const inputElement = document.getElementById(id);

          if (!inputElement) {
            continue;
          }

          const listElement = inputElement.querySelector('.multiselect__content-wrapper');

          let top = defaultTop - this.scrollHeight;

          top += (usersFilter.offsetHeight - 70);
          top += id === 'users-input-container' ? 0 : tagsFilter.offsetHeight - 70;

          listElement.style.top = `${top}px`;
        }
      }, timeout ?? 0);
    },

    scrollHandler(event) {
      this.scrollHeight = event.target.scrollTop;
      this.updateDateRangePosition();
      this.updateMultiselectInputsPosition();
    },
    getTags () {
      this.isLoadingTags = true;
      this.$http.get(`/search/tag?search=${this.searchTag}&page=${this.currentPage}`)
        .then(({ data }) => {
          if (this.currentPage > 1 && !this.searchTag) {
            this.tags = [...this.tags, ...data.tags];
          } else {
            this.tags = data.tags;
          }
          this.totalTags = data.total;
          this.isLoading = false;
        }).finally(() => {
          this.isLoadingTags = false;
        });
    },
    isValidTarget(target) {
      const popoverElement = document.getElementById('filters-popover');
      const closeButton = document.getElementById('close-button');

      if (!popoverElement || !closeButton) {
        return false;
      }

      if (closeButton === target || closeButton.contains(target)) {
        return false;
      }

      return popoverElement.contains(target) ||  Array.from(target.classList).some((className) => className.includes('multiselect'));
    },

    openCloseModalFilter () {
      let isOpened = false;
      window.onmousedown = (event) => {
        if (event.target.id == "btn-filter" || event.target.id == "btn-filter-span") {
          this.isOpened = !this.isOpened;
        } else if (!this.isValidTarget(event.target) && this.isOpened) {
          this.isOpened = false;
          document.getElementById('btn-filter').click();
        }
        if (this.isOpened) {
          document.getElementById("btn-filter").classList.add("deals-filter-button-focus");
        } else {
          document.getElementById("btn-filter").classList.remove("deals-filter-button-focus");
        }
      }
    },
    addQueue (callback) {
      this.queue.push(callback);
      this.runQueue();
    },

    runQueue () {
      if (! this.queue.length || this.loading) {
        return;
      }

      // Remove it from queue.
      const next = this.queue.splice(0, 1)[0];

      // Execute the next callback
      next();
    },

    setPipeline (pipeline) {
      this.pipeline = pipeline;
      this.columns = pipeline.stages;
      this.getBoard();
    },

    setActivity (activity) {
      this.activity = activity;
    },

    setUser (user) {
      this.user_id = user.id;
      this.user_name = user.name;

      this.getBoard();
    },

    setStatus(status) {
      this.status.current = status.type;
      this.status.name = status.name;
    },

    /**
        * Get the board and calculate its width.
        */
    getBoard (filters) {
      const boardhash = this.setNewBoardHash(); // criando um novo boardHash

      if (filters) {
        this.range = filters;
      }

      if (filters === false) {
        this.clearFilters();
      }

      this.calculateBoardSize();

      const promises = Promise.all(this.columns.map((column, i) => {
        this.columns[i].cards = [];
        this.isLoading = false;
        return this.getCards(column.id, i, boardhash); // passando o boardHash para getCards
      }));

      promises.then(() => {
        this.cards = this.dealsTotal();
        this.updatingBoard = false;
      });
      this.isLoading = false;
    },


    clearFilters () {
      this.range = '';
      this.filter = '';
      this.user_id = '';
      this.user_name = '';
    },

    getCards (column, i, boardHash, nextpage = 0, limit = 20) {
      this.loading = true;
      this.columns[i].loading = true;

      const resource = this.$resource('/deal{/column}{/status}');

      const data = {
        column,
        status: this.status.current,
        page: nextpage + 1,
        filter: this.filter,
        users_id: this.selectedUsers.map((user) => user.id),
        tags: this.selectedTags.map((tag) => tag.id),
        createdAt: this.createDateRange,
        closedAt: this.closeDateRange,
        origins: this.origin.id ? [this.origin.id] : null,
        activities: this.activity.id ? this.activity.id : null,
        limit,
        sortField: this.shouldApplySort ? this.option.value : null,
        sortOrder: this.shouldApplySort ? this.option.order : null,
      };

      return resource.get(data)
        .then(async (response) => {
          const { data } = response;
          if (boardHash !== this.boardHash) {
            return;
          }
          const cardConfig = await this.fetchCard();
          const updatedCards = data.data.map((card) => {
              return {
                  ...card,
                  configuration: cardConfig?.configuration || card.configuration || []
              };
          });
          this.columns[i].cards.push(...updatedCards);
          delete data.data;
          this.$set(this.pages, column, data);

          this.columns[i].loading = false;
          this.loading = false;

          this.calculateBoardSize();
        })
        .catch((error) => {
          console.error("[getCards] Erro ao carregar cartões:", error);
        });
    },

    canPaginate (page) {
      if (! page || page.current_page >= page.last_page) {
        return false;
      }

      return true;
    },

    filterCards(cards) {
      return cards.filter(
        (card) => card && typeof card === "object" && typeof card.lead === "object"
      );
    },

    setNewBoardHash () {
      const boardState = {
        pipeline_id: this.pipeline.id,
        user_id: this.user_id,
        status: this.status.current,
        range: this.range,
        filter: this.filter
      }

      const boardHash = Strings.sha256(JSON.stringify(boardState));

      this.boardHash = boardHash;

      return boardHash;
    },


    /**
     * Calculate the board width.
     */
    calculateBoardSize () {
      const width = this.getWidth('#content');
      const columnsWidth = MIN_COLUMN_WIDTH * this.columns.length;

      if (columnsWidth < width) {
        this.board.columnWidth = width / this.columns.length;
        this.board.width = width;
        this.board.scrollable = false;
      } else {
        this.board.columnWidth = MIN_COLUMN_WIDTH;
        this.board.width = (MIN_COLUMN_WIDTH * this.columns.length) + 13;

        try {
          this.board.scrollable = this.getWidth('.scrollable-visible') != this.board.width;
        } catch (e) {
          this.board.scrollable = false;
        }
      }

      this.setScrollVisibility();
    },

    calculateInputDateRangePosition () {
      const windowWidth = window.innerWidth;

      if (windowWidth < 1400) {
        return this.inputDateRangePosition = 'center'
      }

      this.inputDateRangePosition = 'left'
    },

    dealsTotal () {
      return _.map(this.columns, (crr, deals) => deals.length + crr, 0);
    },

    /**
        * Get the scrollable element.
        */
    getScrollableElement () {
      const element = document.scrollingElement || document.documentElement;

      return document.getElementById('board') || element || window.document.body;
    },

    /**
        * Handle Window Scroll
        */
    handleWindowScroll () {
      this.board.scroll.top = window.pageYOffset + document.getElementById('deal-content').offsetTop || FALLBACK_SCROLLABLE_TOP_MARGIN;
    },

    /**
        * Scroll X the board.
        */
    boardScrollX (px) {
      const element = this.getScrollableElement();

      element.scrollLeft += px;

      this.setScrollVisibility();
    },

    /**
        * Scroll X the board when scroll
        */
    wheelBoardScrollX (element) {
      const scrollableElement = this.getScrollableElement();

      if (element.deltaX != 0) {
        scrollableElement.scrollLeft += element.deltaX;
      } else if (element.shiftKey) {
        scrollableElement.scrollLeft += element.deltaY;
      }

      this.setScrollVisibility();
    },

    /**
        * Set the board scroll visibility.
        */
    setScrollVisibility () {
      const container = this.getScrollableElement();

      this.board.scroll.left = container.scrollLeft > 0;
      this.board.scroll.right = (container.offsetWidth + container.scrollLeft) < container.scrollWidth;
    },

    /**
        * Get the column index by id.
        */
    getColumnIndex (id) {
      for (const i in this.columns) {
        if (this.columns[i].id == id) {
          return i;
        }
      }

      return null;
    },

    /**
        * Get a column by id.
        */
    getColumnById (id) {
      return this.columns.filter((column) => column.id == id).pop();
    },

    /**
        * Get a card by id.
        */
    getCardById (id) {
      for (const i in this.columns) {
        for (const j in this.columns[i].cards) {
          if (this.columns[i].cards[j].id == id) {
            return this.columns[i].cards[j];
          }
        }
      }

      return null;
    },

    getCardColumn (id) {
      return this.columns.filter((column) => column.cards.filter((card) => card.id == id).length === 1).pop();
    },

    getCardIndex (id) {
      for (const i in this.columns) {
        for (const j in this.columns[i].cards) {
          if (this.columns[i].cards[j].id == id) {
            return j;
          }
        }
      }

      return null;
    },

    getWidth (selector) {
      const element = document.querySelector(selector);
      const widthElement = getComputedStyle(element).width.replace('px', '');
      return parseFloat(widthElement);
    },

    /**
        * Get the cards total value.
        */
    total (cards) {
      if (! cards) {
        return 0;
      }

      return _.reduce(cards, (total, card) => total + card.value, 0);
    },

    /**
        * Count the cards.
        */
    count (cards) {
      try {
        return cards.length;
      } catch (e) {
        return 0;
      }
    },

    maxCards (column) {
      const page = this.pages[column];

      if (page) {
        return page.total;
      }

      return 0;
    },

    open (deal) {
      if (this.dragging) {
        return this.dragging = false;
      }

      Bus.$emit('open', deal);
    },

    close () {
      Bus.$emit('close');
    },

    reloadColumn (column) {
      const columnIndex = this.getColumnIndex(column);

      if (typeof this.columns[columnIndex] === 'undefined') {
        return;
      }

      this.columns[columnIndex].cards = [];

      this.getCards(column, columnIndex, this.boardHash);
    },

    update (card, column) {
      this.loading = true;

      const columnIndex = this.getColumnIndex(column);

      if (typeof this.columns[columnIndex] === 'undefined') {
        this.loading = false;

        return;
      }

      let cardIndex = this.getCardIndex(card.id);

      if (typeof cardIndex !== 'string') {
        cardIndex = this.columns[columnIndex].cards.length;
      }


      if (this.columns[columnIndex]) {
        this.$set(this.columns[columnIndex].cards, cardIndex, card);
      }

      this.loading = false;
    },

    /**
        * Move a deal to a new stage.
        */
    move ({ added = null, removed = null, moved = null } = {}) {
      if (removed) {
        this.dealToBeUpdated = {
          deal: removed.element,
          stageId: removed.element.stage_id,
          oldIndex: removed.oldIndex
        }
      } else {
        this.dealToBeUpdated = null;
      }

      const event = added || moved;
      if (! event) {
        return;
      }
      const { newIndex: cardIndex, element: card } = event;
      const column = this.getCardColumn(card.id);

      this.updatePaginate(card.stage_id, column.id);

      this.loading = true;
      // Get the order after adding the new card.
      const orders = column.cards.map((card) => card.id);

      this.$http.put(`/deal/${card.id}`, { stage_id: column.id, orders })
        .finally((response) => {
          this.loading = false;
        });
    },

    updatePaginate (oldCol, newCol = null) {
      try {
        if (newCol && ! this.pages[newCol]) {
          this.pages[newCol] = {
            total: 1,
          };
        } else if (newCol) {
          this.pages[newCol].total += 1;
        }

        this.pages[oldCol].total -= 1;
      } catch (e) {
        console.error(e);
      }
    },

    /**
        * Mark card as a given status.
        */
    markAs (card, status) {
      const old = card.status;

      if (status == 'lost' || status == 'closed' || status == 'open') {
        if (old === status) {
          return;
        }

        return this.ask(card, old, status);
      }

      this.updateStatus(card, status);
    },

    startDrag (event) {
      this.checkIfSidebarIsCollapsed();
      this.dragging = true;
    },

    endDrag (event) {
      this.dragging = false;
    },

    drop ({ item: { _underlying_vm_: card } } = {}, action) {
      if (action == 'destroy') {
        return this.destroy(card);
      }

      this.markAs(card, action);
    },

    getOrigins () {
      this.isLoadingOrigins = true;

      this.$http.get('/settings/origin')
        .then(({ body }) => {
            body.unshift({ id: '', name: 'Todas' });

            this.origins = body;
        })
        .catch(() => {
          Alert.error('Falha ao buscar origens');
        })
        .finally(() => {
          this.isLoadingOrigins = false;
        });
    },

    /**
        * Ask user if we should create another deal.
        *
        * If status is lost, ask the reason.
        */
    ask (card, _, status) {
      if (status === 'lost') {
        Bus.$emit('openDealLostReasonModal', card)
      } else if (status === 'closed') {
        Bus.$emit('openDealWonReasonModal', card)
      } else if (status == 'open') {
        Bus.$emit('show-open-observation-modal', card);
      }
    },

    updateReason (card, reason_id, status) {
      this.loading = true;

      if (this.status.current != status) {
        this.remove(card);
      }

      this.updatePaginate(card.stage_id);

      this.$http.put(`/deal/${card.id}`, { reason_id, status })
        .then((response) => {
          card = response.data;

          // if (status === 'lost' || status === 'open') {
          //   Alert.success(`Negócio marcado como ${this.status.names[status]}`);
          // }
        })
        .catch((response) => {
          // Alert.error(`Erro ao marcar negócio como ${this.status.names[status]}`);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // bleh
    askShouldCreateAnotherDeal (card) {
      Swal.fire({
        html:`<div class="swal2-title">${this.__('Deseja criar um <br> novo negócio?')}</div>`
              + '<div><img src="/build/images/deal/create-new-deal-image.svg"></div>',
        width: SWAL_WIDTH,
        buttonsStyling: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        confirmButtonText: this.__('Sim'),
        cancelButtonColor: 'transparent',
        cancelButtonText: this.__('Não'),
        showCancelButton: true,
        customClass: {
          container: 'container-swal2 custom-create-new-deal',
          confirmButton: 'salesflow-btn salesflow-btn-create-new-deal',
          cancelButton: 'btn swal2-btn-cancel-transparent',
        },
        willClose: () => {
          setTimeout(() => {
            Bus.$emit('close');
          }, 500);
        },
      }).then((result) => {
        if (result.dismiss !== 'cancel') {
          Bus.$emit('createDealButtonToggled', [card.lead, card]);
        }
      });
    },

    /**
        * Remove a card.
        */
    remove (card) {
      for (const i in this.columns) {
        for (const j in this.columns[i].cards) {
          if (this.columns[i].cards[j].id == card.id) {
            this.columns[i].cards.splice(j, 1);

            break;
          }
        }
      }
    },

    async destroy(card) {
      this.dealToDelete = card;
      Bus.$emit('openDeleteDealModal');
    },

    async confirmDeletion(observation) {
      const deal = this.dealToDelete;
      if (!deal) return;

      this.loading = true;

      this.$http.delete(`/deal/${deal.id}`, {
        params: { observation }
      })
        .then(() => {
          Alert.success(this.__('Negócio excluído com sucesso!'));

          this.askShouldCreateAnotherDeal(deal);
        })
        .catch(() => {
          Alert.error(this.__('Erro ao excluir negócio'));
        })
        .finally(() => {
          this.dropping = false;
          this.loading = false;
          this.dealToDelete = null;
        });
    },

    updateStatus (card, status) {
      this.loading = true;

      if (this.status.current != status) {
        this.remove(card);
      }

      this.updatePaginate(card.stage_id);

      this.$http.put(`/deal/${card.id}`, { status })
        .then((response) => {
          card = response.data;

          // if (status === 'lost' || status === 'open') {
          //   Alert.success(`Negócio marcado como ${this.status.names[status]}`);
          // }
        })
        .catch((response) => {
          // Alert.error(`Erro ao marcar negócio como ${this.status.names[status]}`);
        })
        .finally((response) => {
          this.dropping = false;
          this.loading = false;
        });
    },

    shouldUpdateBoard (e) {
      const { deal } = e;

      if (e.key == this.user.key) {
        return false;
      }

      if (this.filter) {
        return false;
      }

      if (deal.status !== this.status.current) {
        return false;
      }

      if (this.user_id && deal.user_id !== this.user_id) {
        return false;
      }

      const [from, to] = this.range.split('>');
      const dayjsFrom = dayjs(from, 'DD-MM-YYYY');
      const dayjsTo = dayjs(to, 'DD-MM-YYYY');

      const dateIsBetweenRange = dayjs(deal.expected_at).isBetween(dayjsFrom, dayjsTo)

      if (this.range && !dateIsBetweenRange) {
        return false;
      }

      return true;
    },

    optionSelected(option) {
      this.option = option;
      this.getBoard();
    },

    removeOption() {
      Bus.$emit('sort-popover-position');
      Bus.$emit('clean-order');
      this.option = { name: 'Ordenar' };
      this.$root.$emit('bv::hide::popover', 'deal-sort-popover');
      this.$root.$emit('bv::hide::tooltip', 'sort-tooltip');
      this.getBoard();
    },

    reinsertDealIntoBoard() {
      const { deal, stageId, oldIndex } = this.dealToBeUpdated;
      const columnIndex = this.columns.findIndex(column => column.id === stageId)
      this.columns[columnIndex].cards.splice(oldIndex, 0, deal);
      this.$forceUpdate()
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../sass/variables';
  @import '../../../sass/mixins';

  .configuration-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    column-gap: 20px;
  }

  .dynamic-configuration {
    display: flex;
    align-items: center;
    flex: 0 1 calc(50% - 10px);
    overflow: hidden;
    white-space: nowrap;
  }

  .dynamic-configuration:nth-child(3),
  .dynamic-configuration:nth-child(4) {
    margin-top: 4px;
  }

  .dynamic-configuration span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .icon-class {
    margin-right: 8px;
  }

  .custom-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1050;
  }

  .custom-modal-dialog {
    background: #ffffff;
    border-radius: 16px;
    width: 335px;
    height: 546px;
    padding: 32px;
    gap: 8px;
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .custom-modal-header {
    text-align: center;
    margin-bottom: 0px;
  }

  .custom-modal-title {
    size: 16px;
    line-height: 24px;
    text-align: center;
    font-family: Montserrat;
    font-weight: 600;
    color: #242424;
    height: 24px;
    max-width: 271px;
    white-space: nowrap;
    margin-bottom: 4px;
  }

  .custom-modal-subtitle {
    font-family: Montserrat, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    text-align: center;
    color: #242424;
    width: 243px;
    height: 36px;
    margin: 0 auto;
    display: flex; 
    justify-content: center;
    align-items: center;
    margin-bottom: 40px;
    margin-top: 0px;
  }

  .options-list {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    margin-left: 60px;
    margin-bottom: 16px;
  }

  .option-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-family: Montserrat, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 14.63px;
  }

  input[type="checkbox"] {
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    appearance: none;
    border: 1px solid #ADB1B7;
    border-radius: 4px;
    position: relative;
    cursor: pointer;
  }

  input[type="checkbox"]:checked {
    background-color: #9333EA;
    border-color: #9333EA;
    display: block;
    align-items: center;
    justify-content: center;
  }

  input[type="checkbox"]:checked::after {
    content: '\2713'; 
    font-size: 12px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 100%;
    height: 100%;
    line-height: 16px;
  }

  input[type="checkbox"].disabled-checkbox {
    background: #E5E7EA;
    border: none;
  }

  .disabled-text {
    color: #ADB1B7;
  }

  .disabled-icon {
    color: #ADB1B7;
    opacity: 0.6;
  }

  .btn {
    border: none;
    border-radius: 8px;
    padding: 8px 16px;
    font-family: Montserrat, sans-serif;
    font-size: 12px;
    font-weight: 600;
    line-height: 18px;
    text-align: center;
    cursor: pointer;
  }

  .btn-cancel-text {
    display: block;
    align-items: center;
    justify-content: center;
    margin-top: 8px;
    font-family: Montserrat, sans-serif;
    font-size: 12px;
    font-weight: 600;
    line-height: 18px;
    text-align: center;
    color: #71767D;
    text-decoration: underline;
    text-decoration-style: solid;
    text-underline-position: under;
    cursor: pointer;
    width: 55px;
    height: 18px; 
  }

  .btn-save {
    width: 140px;
    height: 50px;
    background: #2CEBA9;
    color: #242424;
    border: 1px solid #2CEBA9;
    border-radius: 14px;
    padding: 12px 32px;
    font-family: Montserrat, sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    margin-bottom: 8px;
    text-align: center;
    display: inline-block;
    gap: 8px;
  }

  .btn-save:hover {
    color: #FFF;
    border-color: #1DC38A;
    background: #1DC38A;
  }

  .btn-cancel-text:hover {
    color: $salesflow-primary-hover
  }


  .btn-save:disabled {
    background: #ddd;
    border: 1px solid #ddd;
    cursor: not-allowed;
    color: #ADB1B7;
  }

  .custom-modal-footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding-top: 16px;
  }

  .dropdown-menu {
    position: absolute;
    top: 36px;
    left: 0;
    width: 196px;
    height: 74px; 
    background: #FFFFFF;
    border: 1px solid #D1D1D1;
    border-radius: 14px;
    display: flex;
    flex-direction: column;
    padding: 4px 0; 
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
    overflow: hidden; 
  }

  .dropdown-item-drop {
      display: flex;
      align-items: center;
      justify-content: flex-start; 
      padding: 2px 16px; 
      gap: 8px;
      width: 186px;
      height: 32px; 
      background: #FFFFFF;
      font-family: 'Montserrat', sans-serif;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      color: #1E2125;
      text-decoration: none;
      transition: background 0.2s ease-in-out;
      border-radius: 4px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
  }

  .dropdown-item-drop + .dropdown-item-drop {
      margin-top: 2px; 
  }

  .dropdown-item-drop:hover {
      background: #F1F5F9;
  }

  .dropdown-menu::before {
    display: none !important;
  }

  h2.page-subtitle {
    padding-left: 16px;
  }

  .deal-card-body {
    padding: 4px 16px;
  }

  .bdk-card__wrapper {
    display: flex;
    align-items: center;
  }

  .bdk-card__text {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: calc(100% - 18px);
  }

  .status {
    margin-left: 16px;
    margin-top: 8px;

    .btn {
      color: $salesflow-font-gray-light;
      font-size: 1rem;
      font-weight: 400;
      letter-spacing: 0.28px;
      line-height: 150%;
      padding: 0px 0px 2px 0px;
      margin-right: 12px;
      border-radius: 0px;
    }

    .btn.active {
      color: $salesflow-font-gray;
      border-bottom: 2px solid $salesflow-primary;
      opacity: 1;
    }

    .btn:focus {
      box-shadow: none;
    }
  }

  .bottom-status-width-sidebar-collapsed {
    width: calc(100% - 83px);
    margin-left: 83px;
  }

  .bottom-status-width-sidebar-opened {
    width: calc(100% - 189px);
    margin-left: 189px;
  }

  .bottom-status {
    position: fixed;
    background: transparent;
    left: 9px;
    bottom: 0;
    height: 79px;
    z-index: 9;
    font-size: 0.875rem;
    font-weight: 700;
    letter-spacing: 0.28px;
    line-height: 25px;

    .btn {
      height: 80px;
      font-size: 18px;
      border-radius: 0;
    }

    .destroy {
      background-color: $gray;
      color: $gray-dark;
    }

    .lost {
      background-color: $pink;
      color: $white-gray;
    }

    .closed {
      background-color: $green;
      color: $gray-black;
    }

    .open {
      background-color: $orange;
      color: $white-gray;
    }
  }

  .column-list {
    display: flex;
  }

  .scrollable-visible {
    width: 100%;

    &::-webkit-scrollbar {
      width: 0px;  /* remove scrollbar space */
      background: transparent;  /* optional: just make scrollbar invisible */
    }

    /* optional: show position indicator in red */
    &::-webkit-scrollbar-thumb {
      background: transparent;
    }

    #board {
      font-size: 12px;
      width: 100%;
      min-height: 80vh;
      background-color: $salesflow-bg-content;
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      overflow: hidden;

      ul {
        list-style: none;
      }

      .columns {
        float: left;
        background-color: $salesflow-bg-content;

        &:first-child {
          padding-left: 0;
        }

        &:last-child {
          padding-right: 0;
        }

        .header {
          background: $salesflow-bg-content;
          vertical-align: middle;
          color: $salesflow-font-gray;
          font-size: 0.75rem;
          font-weight: 400;
          letter-spacing: -0.18px;
          height: 73px;
          display: flex;
          box-shadow: 0px 12px 20px -20px rgba(0, 0, 0, 0.3);

          &.first {
            padding-left: 16px;
          }

          .content {
            padding: 20px 20px 24px;

            .title {
              color: $salesflow-font-gray;
              font-size: 1rem;
              font-weight: 600;
              line-height: 120%;
              letter-spacing: -0.24px;
            }
          }
        }

        .cards {
          padding: 0;
          height: 100%;
          min-height: 300px;
          margin-top: 22px;

          &.exists {
            min-height: 300px;
          }

          &.first {
            margin-left: 14px;
          }

          &.last {
            margin-right: -5px;
          }

          .card {
            background: transparent;
            display: block;
            height: 180px;
            min-width: 100%;
            border-radius: 0px;
            box-shadow: none;
            padding: 0px;
            color: $salesflow-font-dark;
            font-size: 0.75rem;
            font-weight: 400;
            letter-spacing: -0.18px;

            .row {
              height: 100%;
              min-width: 270px;
              background: $white;
              margin: 12px 8px;
              border-radius: 16px;
              box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);

              &:hover {
                cursor: hand;
                cursor: grab;
                cursor: -moz-grab;
                cursor: -webkit-grab;
              }
            }

            &.sortable-ghost {

              .row {
                height: 100px;
                min-width: 270px;
                background-color: $purple !important;
                margin: 5px 10px;
                border-radius: 15px;
                box-shadow: 0 5px 20px rgba(165, 131, 224, 0.15);
                opacity: 0.5;

                * {
                  display: none;
                }
              }

            }

            a {
              color: #333;

              &:hover {
                text-decoration: none;
              }
            }

            h5.title {
              margin: 0;
              color: $salesflow-primary;
              font-size: 1rem;
              font-weight: 700;
              letter-spacing: -0.21px;
              line-height: 150%;

              .value {
                float: right;
                color: $salesflow-font-dark;
                font-size: 0.75rem;
                font-weight: 600;
                letter-spacing: -0.2px;
                line-height: 125%;
                text-transform: uppercase;
              }
            }

            .details {
              color: #666;
              height: 16px;
              overflow: hidden;
              text-overflow: ellipsis;

              a {
                margin-left: 4px;
                color: #7c7f83;
              }

              i {
                margin: 0 6px;
              }
            }

            span.deal-owner {
              color: $salesflow-font-gray-light;
              font-weight: 500;
              letter-spacing: -0.18px;
              line-height: 21px;
              -webkit-text-stroke: thin;
            }
          }

          .load-more{
            font-weight: normal;
            font-size: 12px;
            -webkit-text-stroke: thin;
          }
        }
      }
    }
  }

  .scrollable-controls {
    width: 100%;
    top: 214px;
    position: absolute;
    padding-left: 20px;

    .pull-front {
      z-index: 10;
    }

    .btn {
      width: 40px;
      height: 40px;
      background-color: $salesflow-outline-gray-light;
      border-radius: 0;
      padding: 0px;
      box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.2);
      border-radius: 50%;

      &.left {
        margin-left: 0.75rem;
      }

      &.right {
        margin-right: 0.75rem;
      }
  }
}

  .deal-board {
    .btn-bulldesk-refresh {
      min-width: unset;
      background-color: $salesflow-primary;
      padding: 0.6875rem;
      border-radius: 14px;
      outline: 0;
      box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
      border: 1px solid $salesflow-primary;
    }

    .btn.btn-bulldesk-transparent {
      outline: 1px solid $salesflow-outline-gray-medium !important;
      border-radius: 14px;
      min-width: 170px;
      font-weight: 600;
      font-size: 0.75rem;
      line-height: 150%;
      padding: 12px 20px;
    }

    .search-field {
      min-width: 224px;
      background-color: transparent;
      color: $salesflow-font-dark;
      padding: 12px 32px;
      border-radius: 14px;
      outline: 1px solid $salesflow-outline-gray-medium;
      font-size: 0.75rem;
      font-weight: 400;
      line-height: 150%;
      padding-left: 30px;
      font-family: 'Inter';
    }
  }

  .pipeline-icon-image-container {
    left: 54px;
    top: 22px;
  }

  .sales-icon-image-container {
    left: 24px;
    top: 14px;
  }

  .search-field::placeholder {
    font-size: 0.75rem;
    font-weight: 400;
    color: $salesflow-font-gray !important;
  }

  .search-icon-image-container {
    left: 24px;
    top: 13px;
  }

  .search-icon-origin {
    position: absolute;
    top: 12px;
    right: 28px;
    z-index: 5;
  }

  .deals-filter-button {
    background-image: url('/build/icons/filter-sale.svg');
    background-repeat: no-repeat;
    background-size: 13px 14px;
    background-position: left 24px top 14px;
    padding: 8px 24px 8px 24px;
    width: 131px;
    height: 42px;
    color:$salesflow-font-gray;
    outline: 1px solid #D1D1D1;
    border-radius: 14px;
  }
  .deals-filter-button:hover {
    background-image: url('/build/icons/filter-sale-white.svg');
    background-color: $salesflow-primary;
    color: $white;
  }

  .deals-filter-button-focus {
    background-image: url('/build/icons/filter-sale-white.svg');
    background-color: $salesflow-primary;
    color: $white;
  }

  .deals-filter-button-text {
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
  }

  #clear-filters-button {
    background: $salesflow-purple-extra-light;
    padding: 12px 24px;
    border: 0px;
    outline: 0px;
    border-radius: 14px;
    @include salesflow-text($font-weight: 600);

    &:not(:disabled):hover {
      background: $salesflow-purple-medium;
      color: white;
    }

    &:disabled {
      color: $salesflow-font-gray-light;
      background: $salesflow-outline-gray-light;
    }
  }

  .modal-filter {
    height: 820px !important;
    max-width: 447px !important;
    width: 447px !important;
    border-radius: 16px !important;
    box-shadow: 0px 0px 50px 0px #0000001A !important;
    border: none !important;
    top:5px !important;
    left:37px !important;

    ::v-deep .arrow:before {
      border-bottom-color: $white !important;
    }

    ::v-deep .popover-body {
      padding: 0px 0px;
    }

    .filter-label {
      @include salesflow-text($color: $salesflow-font-gray);
    }

    ::v-deep .input-date-range-deals-board {
      .form-control {
        display: block;
        width: 399px;
        padding: 9px 12px;
        height: fit-content;

        div {
          display: flex;
        }

        .input-group {
          display: flex;
          align-items: center;
          padding-left: 0px;

          input {
            margin-left: 4px;
            padding: 0px;
          }

          .input-group-append {
            font-size: 1.25rem;
            margin-left: auto;
          }
        }
      }
    }
  }

  ::v-deep .popover-body {
    padding: 0px 0px;
  }

  .filter-label {
    @include salesflow-text($color: $salesflow-font-gray);
  }

  #origin-select ::v-deep {
    width: 100%;

    .multiselect {
      position: relative;
      border: 1px solid $salesflow-outline-gray-medium;
      border-radius: 14px;
    }

    .multiselect__tags {
      height: fit-content;
    }

    .multiselect__input {
      @include salesflow-text($font-weight: 600, $color: $salesflow-font-gray);
      height: fit-content;
      margin-bottom: 0px;
      padding: 12px 9px;
      border-radius: 14px;

      &::placeholder {
        @include salesflow-text($font-weight: 600, $color: transparent);
      }
    }

    .multiselect__single {
      @include salesflow-text($font-weight: 600, $color: $salesflow-font-gray);
      height: fit-content;
      margin-bottom: 0px;
      padding: 12px 9px;
      border-radius: 14px;
      max-width: 90%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .search-icon {
      position: absolute;
      top: 12px;
      right: 28px;
      z-index: 5;
    }

    .multiselect__placeholder {
      @include salesflow-text($font-weight: 600, $color: $salesflow-font-gray);
      margin-bottom: 0px;
      padding: 12px 9px;
    }

    .multiselect__content-wrapper {
      padding: 8px 0px;
      margin-top: 4px;
      background: white;
      border-radius: 14px;
      border: 1px solid $salesflow-outline-gray-medium;

      .multiselect__option {
        @include salesflow-subtitle($color: $salesflow-font-dark);
        padding: 4px 16px;
        background: white;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
        max-width: 100%;
        min-height: auto;

        &:hover {
          background: $salesflow-outline-gray-medium;
        }
      }

      &::before {
        display: none;
      }
    }
  }

  #origins-input-container ::v-deep .multiselect__option--selected {
    background: white;
  }

  @media screen and (min-height: 580px) and (max-height: 680px) {
    .modal-filter {
      max-height: 450px !important;
    }

    .body-content {
      height: 370px;
    }
  }

  @media screen and (min-height: 680px) and (max-height: 740px) {
    .modal-filter {
      max-height: 500px !important;
    }

    .body-content {
      height: 420px;
    }
  }

  @media screen and (min-height: 740px) and (max-height: 910px){
    .modal-filter {
      max-height: 550px !important;
    }
    .body-content {
      height: 465px;
    }
  }

  @media screen and (min-height: 910px) and (max-height: 1008px){
    .modal-filter {
      max-height: 700px !important;
      top: 20px !important;
    }
    .body-content {
      height: 615px;
    }
  }

  @media screen and (min-height: 1009px) {
    .modal-filter {
      max-height: 820px !important;
    }
    .body-content {
      height: 735px;
    }
  }

  ::v-deep .popover-body {
    padding: 0px 0px;
  }

  .filter-label {
    @include salesflow-text($color: $salesflow-font-gray);
  }

  ::v-deep .input-date-range-deals-board {
    .form-control {
      display: block;
      width: 399px;
      padding: 9.5px 12px !important;
      height: fit-content !important;

      div {
        display: flex !important;
      }

      .input-group {
        display: flex !important;
        align-items: center !important;
        padding-left: 0px !important;

        input {
          margin-left: 4px !important;
          padding: 0px !important;
        }

        .input-group-append {
          font-size: 1.25rem !important;
          margin-left: auto !important;
        }
      }
    }
  }

  .close {
    font-size: 35px;
    font-weight: 300;
    position: absolute;
    right: 15px;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  .pipeline-select {
    width: 194px;
    outline: unset !important;

    ::v-deep .btn.btn-bulldesk-transparent {
      padding-top: 11px;
      padding-bottom: 11px;
      padding-left: 44px;
    }
  }

  ::v-deep .multiselect {
    width: 399px;
    height: auto;
    right: 15px;
    border: 1px solid $salesflow-outline-gray-medium;
    border-radius: 14px;
    font-weight: 600;
    line-height: 18px;
  }

  ::v-deep .multiselect__placeholder {
    @include salesflow-text($color: $salesflow-font-gray, $font-weight: 600);
    left: 12px;
    position: relative;
    padding: 12px 0px 2px 0px;
  }

  ::v-deep .multiselect__tag {
    border-radius: 4px;
    background-color: $salesflow-purple-extra-light;
    width: 113px;
    height: 20px;
    color:$salesflow-font-dark;
    margin: 0px;
    font-size: 12px;
  }

  ::v-deep .multiselect__tags {
    height: fit-content;
  }

  ::v-deep .multiselect__tag-icon:hover {
    background-color: $salesflow-purple-extra-light;
  }
  ::v-deep .multiselect__tag-icon:after {
    color:$salesflow-outline-gray;
    font-size: 26px;
    width: 7.5px;
    height: 7.5px;
    font-weight: 100;
    position: absolute;
    bottom: 15px;
    right: 8px;
    left: 1.25px;
    top: -0.75px;
  }

  ::v-deep .multiselect__content {
    background-color: $white;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    color: $salesflow-purple-extra-dark;
  }
  ::v-deep .multiselect__tags-wrap {
    width: 399px;
    padding: 11px;
    flex-wrap: wrap;
    gap: 8px;
    display: flex;
  }

  ::v-deep .multiselect__content-wrapper {
    position: fixed;
    width: 399px;
    border-radius: 14px;
    box-shadow: none;
    border: 1px solid $salesflow-outline-gray-medium;
    border-top: 1px solid $salesflow-outline-gray-medium;
    margin-top: 5px;
  }

  ::v-deep .multiselect__content-wrapper:before {
    border-bottom: $white;
  }

  ::v-deep .daterangepicker {
    position: fixed;
  }

  ::v-deep .daterangepicker::after {
    display: none !important;
  }

  ::v-deep .daterangepicker::before {
    display: none !important;
  }

  .filter-icon {
    right:4px;
    top:57%;
    position:absolute !important
  }

  .filter-user-label {
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: left;
    color: $salesflow-font-gray;
    position: relative;
    right: 15px;
  }

  ::v-deep .multiselect__option.multiselect__option--selected {
    background-color: $salesflow-purple-extra-light;
    font-weight: 400;
    color:$salesflow-purple-extra-dark;
  }

  ::v-deep .multiselect--active {
    width: 399px !important;
    height: fit-content;
    right: 15px;
    z-index: initial;
  }

  ::v-deep .multiselect__input {
    @include salesflow-text($color: $salesflow-font-gray, $font-weight: 600);
    border-radius: 14px;
    height: auto;
    padding: 12px 30px 12px 12px;
    margin-bottom: 0px;
    border-bottom-left-radius: 14px !important;
    border-bottom-right-radius: 14px !important;

    &::placeholder {
      color: transparent !important;
      opacity: 0 !important;
    }
  }

  ::v-deep .multiselect__option--highlight {
    color:#1E293B;
    background-color: $salesflow-outline-gray-medium;
  }

  ::v-deep .multiselect__option {
    padding: 4px 16px;
    min-height: 0px;
  }

  ::v-deep .popover-body {
    height: 100%;
    padding:0px;
  }

  ::v-deep .body-header {
    height: 35px;
    background-color: white;
    border-radius: 14px;
    padding: 16px 24px;
    box-sizing: border-box;
    position: relative;
  }

  ::v-deep .body-content {
    padding: 0px 24px 16px 24px;
    overflow-x: hidden;
    overflow-y: scroll;
  }

  ::v-deep .multiselect__single {
    @include salesflow-text($font-weight: 600, $color: $salesflow-font-gray);
    height: fit-content;
    margin-bottom: 0px;
    padding: 12px 9px;
    border-radius: 14px;
    max-width: 90%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .multiselect__content-wrapper {
    padding: 8px 0px;
    margin-top: 4px;
    background: white;
    border-radius: 14px;
    border: 1px solid $salesflow-outline-gray-medium;
  }

  ::v-deep .multiselect__option {
    @include salesflow-subtitle($color: $salesflow-font-dark);
    padding: 4px 16px;
    background: white;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    max-width: 100%;
    min-height: auto;

    &:hover:not(.multiselect__option--selected) {
      background: $salesflow-outline-gray-medium;
    }
  }

  .filter-activities {
    width: 399px;
    height: 42px;
    right: 15px;

    ::v-deep .btn.btn-bulldesk-transparent {
      height:42px;
    }

    ::v-deep .btn.btn-bulldesk-transparent > span{
      @include salesflow-text($color: $salesflow-font-gray, $font-weight: 500);
      left: 10px;
      position: absolute;
      padding: 12px 0px 12px 0px;
    }

    ::v-deep .dropdown-menu {
      margin-top: 4px;
    }

    ::v-deep .dropdown-item {
      min-height:auto;
    }
  }

  #clear-filters-button {
    background: $salesflow-purple-extra-light;
    padding: 12px 24px;
    border: 0px;
    outline: 0px;
    border-radius: 14px;
    @include salesflow-text($font-weight: 600);

    &:not(:disabled):hover {
      background: $salesflow-purple-medium;
      color: white;
    }

    &:disabled {
      color: $salesflow-font-gray-light;
      background: $salesflow-outline-gray-light;
    }
  }

  .deals-filter-button-filled {
    background-image: url('/build/icons/filter-sale.svg');
    background-repeat: no-repeat;
    background-size: 13px 14px;
    background-position: left 24px top 14px;
    padding: 8px 24px;
    width: 135px;
    height: 42px;
    background-color:#D4C9FF;
    color:$salesflow-font-gray;
  }

  .deals-filter-button-filled:hover {
    background-image: url('/build/icons/filter-sale-white.svg');
    background-color: $salesflow-primary;
    color: $white;
  }

  .deals-filter-button-filled-focus {
    background-image: url('/build/icons/filter-sale-white.svg');
    background-repeat: no-repeat;
    background-size: 13px 14px;
    background-position: left 24px top 14px;
    padding: 8px 24px;
    width: 135px;
    height: 42px;
    background-color: $salesflow-primary;
    color: $white;
  }

  ::v-deep .load-more {
    cursor: pointer;
    color: #71767D;
    padding: 5px;
    justify-content: center;
    display: flex;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
  }

  .baseboard {
    height: 50px;
    gap:4px;
    border-top: 1px solid $salesflow-outline-gray-medium;
    font-weight: 500;
    font-size: 12px;
    color: $salesflow-font-gray;
    justify-content: center;
    align-items: center;
  }

  .clear-search-field {
    top: -3px;
    right: 12px;
    font-size: 32px;
    color: $salesflow-font-gray !important;

    &:hover {
      cursor: pointer;
    }

    span {
      font-weight: 100;
    }
  }

  .baseboard > a {
    font-weight: 600;
    font-size: 12px;
    color: $salesflow-primary;
    text-decoration: underline;
  }

  .btn-configuration {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    border-radius: 12px;
    background-color: #886AF8;
    padding: 0;
  }

  .btn-configuration img {
    width: 16px;
    height: 16px;
    object-fit: contain;
  }

  .btn-configuration:hover {
    background-color: $salesflow-primary-hover;
  }

  .btn-configuration:active {
    background-color: $salesflow-primary-hover !important;
  }

  ::v-deep .tooltip-inner {
    padding: 8px 12px 8px 12px !important;
    border-radius: 8px !important;
    font-family: 'Inter';
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
  }

  .sort-button {
    display: flex;
    justify-content: center;
    height: 42px;
    padding: 9px 24px;
    align-items: center;
    gap: 8px;
    border-radius: 14px;
    background: $salesflow-primary;
    border: none;
    transition: 300ms ease-out;
    color: #FFF;
    font-family: Montserrat;
    font-size: 12px;
    font-weight: 600;
    line-height: 130%;
    min-width: 145px;
  }

  .sort-button:hover {
    background: $salesflow-primary-hover;
  }

  .sortTooltipArrow ::v-deep .tooltip-inner {
    background: #000 !important;
    border-radius: 8px !important;
    padding: 4px 8px !important;
    font-family: Inter;
    font-weight: 500;
    font-size: 12px;
    max-width: 170px;
  }

  .sortTooltipArrow ::v-deep .arrow {
    left: 50% !important;
    transform: translateX(-50%);
  }

  .sortTooltipArrow ::v-deep .arrow::before {
    border-bottom-color: #000 !important;
  }
  
  .opportunity-border {
    border: 1px solid #EFCD34;
  }

  .gap-2-3 {
    gap: 10px;
  }

  .gap-2 {
    gap: 8px;
  }

  .gap-1 {
    gap: 4px;
  }

  .rounded-square-32 {
    width: 32px !important;
    height: 32px !important;
    border-radius: 4px !important;
  }

  .fs-6 {
    font-size: 16px !important;
  }

  .fs-7 {
    font-size: 14px !important;
  }

  .fs-8 {
    font-size: 12px !important;
  }

  .fs-9 {
    font-size: 10px !important;
  }

  .lh-20 {
    line-height: 20px !important;
  }

  .lh-18 {
    line-height: 18px !important;
  }

  .lh-16 {
    line-height: 16px !important;
  }

  .lh-14 {
    line-height: 14px !important;
  }

  .lh-10 {
    line-height: 10px !important;
  }

  .font-montserrat {
    font-family: 'Montserrat' !important;
  }
  
  .fw-normal {
    font-weight: 400 !important;
  }

  .fw-regular {
    font-weight: 500 !important;
  }

  .fw-semibold {
    font-weight: 600 !important;
  }

  .fw-bold {
    font-weight: 700 !important;
  }

  .mb-3-5 {
    margin-bottom: 20px !important;
  }
  
  .mb-2-5 {
    margin-bottom: 12px !important;
  }

  .mt-3-5 {
    margin-top: 20px !important;
  }

  .my-1-5 {
    margin-top: 6px !important;
    margin-bottom: 6px !important;
  }

  .mh-39 {
    max-height: 39px !important;
  }

  .pr-2-5 {
    padding-right: 12px !important;
  }

  .py-2-5 {
    padding-top: 12px !important;
    padding-bottom: 12px !important;
  }

  .py-2-3 {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }

  .pb-1-5 {
    padding-bottom: 6px !important;
  }

  .purple-text {
    color: #886AF8 !important;
  }

  .bg-gray-light {
    background-color: #F1F5F9 !important;

    &:hover {
      background-color: #F4F1FF !important;
    }
  }

  .exclamation-octagon-filled:hover path {
    fill: #FF2E56 !important;
  }

  .check-circle-filled:hover path {
    fill: #07A588 !important;
  }

  .filled-clock:hover path {
    fill: #5F33FF !important;
  }

  .hourglass:hover path {
    fill: #5F33FF !important;
  }

  .hot-deal {
    &:hover path {
      fill: white !important;
    }
  }

  .hot-deal.bg {
    background-color: #FFD9D9 !important;

    &:hover {
      background-color: #FF2E56 !important;
    }
  }

  .neutral-deal {
    &:hover path {
      fill: white !important;
    }
  }

  .neutral-deal.bg {
    background-color: #FFECCF !important;

    &:hover {
      background-color: #F88317 !important;
    }
  }

  .cold-deal {
    &:hover path {
      fill: white !important;
    }
  }

  .cold-deal.bg {
      background-color: #E5F1FF !important;

      &:hover {
        background-color: #0C81ED !important;
      }
  }

  .row-gap-1-5 {
    row-gap: 6px !important;
  }

  .border-light-gray {
    border-color: #f5f5f5 !important;
  }

  .text-gray {
    color: #999999 !important;
  }

  .text-gray-strong {
    color: #555151 !important;
  }

  .radius-8 {
    border-radius: 8px !important;
  }

  .config-label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    max-width: calc(100% - 24px);
  }

  .icon-class {
    flex-shrink: 0;
    margin-right: 8px;
  }
</style>
